import { i18n } from "@lingui/core";
import { Trans } from "@lingui/react";
import { Alert } from "@warp-ds/elements/react/alert";
import { Box } from "@warp-ds/elements/react/box";
import { useAdViewMeta } from "../../context/AdViewProviderContext.tsx";
import { useAppConfig } from "../../context/AppConfigProviderContext.tsx";

const AdInfo = () => {
  const { isPreview, breadcrumbs } = useAppConfig();
  const { mode } = useAdViewMeta();
  const isInactive = mode !== "PLAY";

  if (isPreview) {
    return (
      <Box info className="m-16">
        <Trans
          id="itemPageLayout.preview.info"
          message="This is your advertisement. It is only visible to you until it is published."
          comment="Info shown to the seller when previewing their own unpublished ad"
        />
      </Box>
    );
  }
  if (isInactive) {
    const [, l2, l3, l4] = breadcrumbs;
    const link = (l4 || l3 || l2).path;
    const makeModel = l3 ? `${l3?.text}${l4 ? ` ${l4.text}` : ""}` : l2?.text;

    return (
      <Alert className="mt-16 md:mt-32" variant="negative" show>
        <h3 className="t4 -mt-2">
          <Trans
            id="itemPageLayout.adinfo.inactive.title"
            message="This ad is no longer available"
            comment="Heading of the alert shown on inactive ads"
          />
        </h3>
        <p>
          <Trans
            id="itemPageLayout.adinfo.inactive.description"
            message="The item has been sold or taken off the market by the seller."
            comment="Description in the alert shown on inactive ads"
          />
        </p>
        {makeModel && (
          <p>
            <a href={link}>
              {i18n.t({
                id: "itemPageLayout.adinfo.inactive.linkPrefix",
                message: "View other {makeModel}",
                values: { makeModel: makeModel },
              })}
            </a>
          </p>
        )}
      </Alert>
    );
  }

  return null;
};

export default AdInfo;
